import { useContext } from 'react';
import AuthContext from '../presentation/contexts/AuthContext';

/**
 * 認証コンテキストへアクセスするためのカスタムフック
 */

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuthはAuthProvider内で使用する必要があります');
  }

  return context;
};

/**
 * ユーザーが特定のロールを持っているか確認
 */
export const useHasRole = (role: 'admin' | 'doctor' | 'staff'): boolean => {
  const { user } = useAuth();
  return user?.role === role;
};

/**
 * ユーザーが管理者かどうか確認
 */
export const useIsAdmin = (): boolean => {
  return useHasRole('admin');
};

/**
 * ユーザーが医師かどうか確認
 */
export const useIsDoctor = (): boolean => {
  return useHasRole('doctor');
};

/**
 * ユーザーがスタッフかどうか確認
 */
export const useIsStaff = (): boolean => {
  return useHasRole('staff');
};

export default useAuth;
